import { TDateISODate } from "api/common/types/datetime.types";

export const statusColors = {
  Archived: "#fd7e14",
  Publishing: "#198754",
} as const;

export type StatusType = "Archived" | "Approved";

interface StatusInfo {
  isArchived: boolean;
  statusColor: string;
  statusLabel: StatusType;
}

export const getStatusInfo = (sunsetDate: TDateISODate | null): StatusInfo => {
  const isArchived = sunsetDate ? new Date(sunsetDate) < new Date() : false;

  return {
    isArchived,
    statusColor: isArchived ? statusColors.Archived : statusColors.Publishing,
    statusLabel: isArchived ? "Archived" : "Approved",
  };
};
